// 请不要改动这个文件，如果需要在Vue.prototype上添加方法或者变量，请团队沟通

import { Loading, Message, Notification } from 'element-ui';

let setVuePrototypeMethods = {};

setVuePrototypeMethods.install = function (Vue, options) {
  Vue.prototype.yhcLoadingShow = window.yhcLoadingShow = function (methodOptions = {}) {
    let code = Object.assign(
      {
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      },
      methodOptions
    );

    window.yhcLoadingInstance = Loading.service(code);
  };

  Vue.prototype.yhcLoadingHide = window.yhcLoadingHide = function (methodOptions) {
    window.yhcLoadingInstance && window.yhcLoadingInstance.close();
  };

  Vue.prototype.yhcToastShow = window.yhcToastShow = function (methodOptions = {}) {
    let code = Object.assign(
      {
        message: '操作成功',
        type: 'success',
        // type: 'error',
        // type: 'warning',
        showClose: true,
      },
      methodOptions
    );

    Message(code);
  };

  Vue.prototype.yhcNotifyShow = window.yhcNotifyShow = function (methodOptions = {}) {
    let code = Object.assign(
      {
        title: '系统消息',
        message: '',
        type: 'success',
      },
      methodOptions
    );
    Notification(code);
  };

  Vue.prototype.yhcNotifyHide = window.yhcNotifyHide = function (methodOptions) {};
};

export default setVuePrototypeMethods;
